
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import TabSeminar from '@/components/elements/TabSeminar.vue'
import HospitalSearchForm from '@/components/block/HospitalSearchForm.vue'
import SavedSearchCondition from '@/components/block/SavedSearchCondition.vue'

export default defineComponent({
  components: {
    TabSeminar,
    SavedSearchCondition,
    HospitalSearchForm
  },

  setup() {
    const store = useStore()
    const formMode = ref('default')

    const tab = [
      {
        label: '病院・初期研修'
      },
      {
        label: '専門研修'
      }
    ]
    const defaultTab =
      store.state.userInfo?.member_type === '初期研修医' ? 1 : 0
    const currentTab = ref(defaultTab)
    const clickTab = (i: number) => (currentTab.value = i)
    const changeFormMode = (mode: string) => (formMode.value = mode)

    const modalTitle = computed(() => {
      if (formMode.value === 'option') return '検索オプション'
      if (formMode.value === 'area') return '病院所在地'
      return '病院検索'
    })

    // モーダルのヘッダーとフッターがスクロールバーに被らないようにする
    const modalScrollBarWidth = ref(0)
    onMounted(() => {
      const body = document.querySelector('body')
      const modal = document.getElementById('searchModal')

      if (body && modal) {
        const scrollBarWidth = body.clientWidth - modal.clientWidth
        const h = document.getElementById('searchModalHeader')
        if (h) h.style.width = `calc(100% - ${scrollBarWidth}px)`
        modalScrollBarWidth.value = scrollBarWidth
      }
    })

    const showOption = async () => {
      const isLogin = await store.dispatch('checkLogin')
      if (!isLogin) return

      formMode.value = 'option'
    }

    return {
      formMode,
      tab,
      currentTab,
      clickTab,
      changeFormMode,
      modalTitle,
      modalScrollBarWidth,
      showOption
    }
  }
})
